module.exports = __webpack_public_path__ + "static/media/handshake.db15e160.jpg";